module.exports = __webpack_public_path__ + "img/2.141e9853.jpg";